module.exports = __webpack_public_path__ + "img/16kQruqI2XTPP4h4I-WbqwfTZTdXNyoDr.68d6a70c.jpg";